import { useState, useEffect } from "react";

import illustrationError from "./illustration_error.svg";
import illustrationSuccess from "./illustration_success.svg";
import queryString from "query-string";
import API_URL from "../components/ApiUrl";
import { useTranslation } from "react-i18next";

const VerifyEmail = () => {
  const { t } = useTranslation();
  const [httpStatus, setHttpStatus] = useState(500);
  const [loading, setLoading] = useState(true);
  const parsed = queryString.parse(window.location.search);
  console.log(parsed);
  const token = parsed.token;

  useEffect(() => {
    fetch(`${API_URL}/users/verify-email?token=${token}`)
      .then((response) => {
        console.log(response);
        setHttpStatus(response.status);
      })
      .catch((error) => {
        console.error(error);
        setHttpStatus(401);
      })
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="content">
        <p>Loading...</p>
      </div>
    );
  } else if (httpStatus === 204) {
    return (
      <div className="content">
        <img src={illustrationSuccess} className="illustration-icon" alt={t('success')} />
        <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>{t('verify.success.title')}</h1>
        <p style={{ fontSize: "18px", color: "#2b3136", textAlign: "center" }}>{t('verify.success.body')}</p>
      </div>
    );
  } else {
    return (
      <div className="content">
        <img src={illustrationError} className="illustration-icon" alt={t('fail')} />
        <h1 style={{ fontSize: "36px", fontWeight: 600, color: "#4d4d4d" }}>{t('verify.fail.title')}</h1>
        <p style={{ fontSize: "18px", color: "#2b3136", textAlign: "center" }}>{t('verify.fail.body')}</p>
      </div>
    );
  }
};

export default VerifyEmail;
